/** Where a battle's back and close buttons lead: the screen the fight was started from. */
export function battleReturnRoute(context: string): string {
  switch (context) {
    case "nexus": return "/app/nexus";
    case "arena": return "/app/arena";
    case "expedition": return "/app/expeditions";
    case "siege": return "/app/events";
    case "pack": case "hive": case "boss": case "base_attack": case "zone": return "/app/map";
    default: return "/app/units";
  }
}
